<template lang="pug">
    .container(ref='container')
        .animated-scroll(
            ref='animatedScroll'
            )
            svg(viewBox='0 0 1280 720' preserveAspectRatio='xMidYMid meet')
                g(ref='skullLeft')
                    path(fill-rule='evenodd' clip-rule='evenodd' d='M330.562 221.067L447.103 362.33L362.749 340.668L544.215 583.687V578.874V634.506H498.105V611.924H477.271V634.506H443.827V611.924H421.896V634.506H388.452V611.924H367.618V634.506H321.453V578.819L226 498.249V400.797C226.037 323.828 268.137 256.674 330.562 221.067ZM433.684 487.068L457.698 527.188H407.97L433.684 487.068ZM403.42 442.891C403.42 474.352 377.87 499.893 346.4 499.893C314.874 499.893 289.38 474.406 289.38 442.891C289.38 411.43 314.929 385.889 346.4 385.889C377.87 385.889 403.42 411.43 403.42 442.891Z' fill='black')
                g(ref='skullRight')
                    path(fill-rule='evenodd' clip-rule='evenodd' d='M328 222.5L428 353.5L346.5 333.5L544.214 595V578.874L639.668 498.304V400.852C639.668 286.628 547.065 194.055 432.861 194C395.65 194.018 358.17 205.291 328 222.5ZM576.343 442.891C576.343 474.352 550.794 499.893 519.323 499.893C487.852 499.893 462.303 474.407 462.303 442.891C462.303 411.43 487.852 385.889 519.323 385.889C550.794 385.889 576.343 411.43 576.343 442.891Z' fill='black')
                g(ref='ax')
                    path(d='M917.47 183.564C917.47 183.564 960.32 48.6529 1104.36 14.0073C1104.36 14.0073 1122.21 127.527 1156.15 176.37L1164 169.001L1217.5 225.501L1211 232L1226.5 245.5L1161.93 316.17L1147.22 303.945C1147.22 303.945 1122.91 337.121 1065.28 365.114C1007.65 393.106 901.73 589.643 901.73 589.643C901.73 589.643 828.302 697.628 762.031 726.025C762.031 726.025 713.097 703.215 726.063 656.85C726.063 656.85 833.108 594.85 862.809 532.679C892.51 470.508 1045 267.501 1085.8 247.804L1077.39 240.073C1077.39 240.073 1090.58 226.119 1077.21 220.69C1063.85 215.261 992.937 218.122 992.937 218.122L917.47 183.564Z' fill='black')
</template>
<script>
import {gsap} from 'gsap';
import {mixinAnimation} from '../mixins/animatedScreen';

//import * as basicScroll from 'basicscroll';

export default {
    props: {
        rows: {
            type: String
        },
        modifierClass: String,
        settings: Object,
        isActive: Boolean
    },
    mixins: [mixinAnimation],
    methods: {
        createAnimation() {
            this.createTimeline();
            this.createScroll();
        },
        createTimeline() {
            this.timeline = gsap.timeline({paused: true});
            this.timeline
                .fromTo(this.$refs.ax, {rotate: 0, y: 0, x: 0}, {duration: 1, rotate: -80, x: 10, y: -200, ease: 'power2.in', transformOrigin: '10% 90%'})
                .fromTo(this.$refs.skullLeft, {y: 0, x: 0}, {duration: 1, x: -150, y: -200, ease: 'power2.in'}, 1)
                .fromTo(this.$refs.skullRight, {y: 0, x: 0}, {duration: 1, x: 150, y: 200, ease: 'power2.in'}, 1)
                .fromTo(
                    this.$refs.ax,
                    {rotate: -80, x: 10, y: -200},
                    {duration: 1, rotate: -130, x: 300, y: -500, ease: 'power2.out', transformOrigin: '10% 90%'},
                    1
                );
            this.timeline.progress(0.0001);
        }
    }
};
</script>
<style lang="scss" scoped>
@import '../../assets/css/vars.scss';

.container {
    height: 150vh;
    position: relative;
    overflow: hidden;
}

.animated-scroll {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 0;
    height: auto;
    width: 100%;
    height: 100vh;
    background-color: var(--color-red);
}

svg {
    width: 100%;
    height: 100vh;
}
</style>
